<template>
  <v-list-tile v-if="list" @click.capture.stop="navigate" :to="route">
    <v-list-tile-action>
      <v-icon color="primary" class="theme--light">comment</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      {{ $t('message.metadata.comments') }}
    </v-list-tile-content>
  </v-list-tile>
  <v-tooltip top v-else>
    <template #activator="{on}">
      <v-btn v-on="on" class="ma-0" icon @click.capture.stop="navigate" :to="route">
        <v-icon color="primary" class="theme--light">comment</v-icon>
      </v-btn>
    </template>
    <strong v-html="$t('message.metadata.comments')"></strong>
  </v-tooltip>
</template>

<script>
export default {
  name: 'nx-list-action-user-comments',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    list: {
      type: Boolean,
    },
  },
  computed: {
    route() {
      return {
        name: 'searcher',
        params: { entity: 'comment' },
        query: { userId: this.id },
      };
    },
  },
  methods: {
    navigate() {
      this.$router.push(this.route);
    },
  },
};
</script>
